require('../position/position.css');
module.exports = require('./index-nocss.js');



// WEBPACK FOOTER //
// ./node_modules/angular-ui-bootstrap/src/modal/index.js